<template>
  <Loading v-if="!report" />
  <div v-else id="dashboard-analytics">
    <p class="mb-8">
      Updates daily. Report generated at {{ report.date | formatDate }}
    </p>
    <h4 class="mb-8">Guests</h4>
    <div class="vx-row">
      <!-- CARD 1: NEW ARTICLES -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <statistics-card-line
          icon="TrendingUpIcon"
          :statistic="`${report.guestProfileStats.numGuestsFirstActive30Days} new guests`"
          statisticTitle="Registered last 30 days"
          :chartData="newGuestsSeries"
          color="success"
          type="area"
        ></statistics-card-line>
      </div>

      <!-- CARD 2: USERS REGISTERED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          icon="UsersIcon"
          :statistic="`${report.guestProfileStats.numGuests}`"
          statisticTitle="Total guests registered"
          :chartData="newGuestsSeries"
          type="area"
        ></statistics-card-line>
      </div>

      <!-- CARD 3: USER SESSIONS -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line
          icon="ActivityIcon"
          :statistic="`${report.guestProfileStats.numGuestsLastActive30Days}`"
          statisticTitle="Active guests last 30 days"
          :chartData="activeGuestsSeries"
          color="primary"
          type="area"
        ></statistics-card-line>
      </div>
    </div>

    <h4 class="mb-8">Campaigns</h4>
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->

      <!-- CARD 8: Activity Timeline -->
      <div class="vx-col w-full lg:w-1/4 mb-base">
        <vx-card title="Venue Campaigns">
          <vue-apex-charts
            type="pie"
            height="420"
            :options="venueCampaignStatusData.chartOptions"
            :series="venueCampaignStatusData.series"
          />

          <ul>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-primary
                  "
                ></span>
                <span class="font-semibold">Total</span>
              </span>
              <span>{{ report.venueCampaignStats.numCampaigns }}</span>
            </li>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-warning
                  "
                ></span>
                <span class="font-semibold">Created by venue</span>
              </span>
              <span>{{ report.venueCampaignStats.numCreatedByVenue }}</span>
            </li>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-danger
                  "
                ></span>
                <span class="font-semibold">Created by HQ</span>
              </span>
              <span>{{ report.venueCampaignStats.numCreatedByHQ }}</span>
            </li>
          </ul>
          <!-- <vx-timeline :data="upcomingEvents" /> -->
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/4 mb-base">
        <vx-card title="HQ Campaigns">
          <vue-apex-charts
            type="pie"
            height="420"
            :options="masterCampaignStatusData.chartOptions"
            :series="masterCampaignStatusData.series"
          />

          <ul>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-primary
                  "
                ></span>
                <span class="font-semibold">Total</span>
              </span>
              <span>{{ report.masterCampaignStats.numCampaigns }}</span>
            </li>
          </ul>
          <!-- <vx-timeline :data="upcomingEvents" /> -->
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card
          slot="no-body"
          class="text-center bg-primary-gradient greet-user"
        >
          <div class="vx-row">
            <div class="vx-col lg:w-1/4 mb-base">
              <feather-icon
                icon="MessageCircleIcon"
                class="
                  p-6
                  mb-8
                  bg-primary
                  inline-flex
                  rounded-full
                  text-white
                  shadow
                "
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">
                {{ report.venueCampaignStats.numSmsSent }}
              </h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                SMS sent
              </p>
            </div>
            <div class="vx-col lg:w-1/4 mb-base">
              <feather-icon
                icon="MailIcon"
                class="
                  p-6
                  mb-8
                  bg-primary
                  inline-flex
                  rounded-full
                  text-white
                  shadow
                "
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">
                {{ report.venueCampaignStats.numEmailsSent }}
              </h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                Emails sent
              </p>
            </div>
            <div class="vx-col lg:w-1/4 mb-base">
              <feather-icon
                icon="SendIcon"
                class="
                  p-6
                  mb-8
                  bg-primary
                  inline-flex
                  rounded-full
                  text-white
                  shadow
                "
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">
                {{ report.venueCampaignStats.numCampaigns }}
              </h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                Total venue campaigns
              </p>
            </div>
            <div class="vx-col lg:w-1/4 mb-base">
              <feather-icon
                icon="HomeIcon"
                class="
                  p-6
                  mb-8
                  bg-primary
                  inline-flex
                  rounded-full
                  text-white
                  shadow
                "
                svgClasses="h-8 w-8"
              ></feather-icon>
              <h1 class="mb-2 text-white">
                {{ report.venueCampaignStats.mapEmailsSentByVenue.length }}
              </h1>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
                Venues
              </p>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <h4 class="mb-8">Engage</h4>
    <div class="vx-row">
      <!-- CARD 6: Product Orders -->

      <!-- CARD 7: Learning Stats -->
      <!-- <div class="vx-col w-full lg:w-1/3 mb-base"> -->
      <!-- <vx-card title="Online Training Assessment" subtitle="Last Month">
          <template slot="actions">
            <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
          </template>
          <div class="flex">
            <span class="flex items-center"
              ><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div>
              <span>Score</span></span
            >
            !--<span class="flex items-center ml-4"><div class="h-3 w-3 rounded-full mr-1 bg-success"></div><span>Visits</span></span>
          </div>
          <div slot="no-body-bottom">
            <vue-apex-charts
              type="radar"
              height="430"
              :options="learningRadarOptions.chartOptions"
              :series="learningRadar.series"
            />
          </div>
        </vx-card> -->
      <!-- </div> -->

      <!-- CARD 8: Activity Timeline -->
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Messenger activity">
          <vx-timeline :data="engageMessengerActivity" />

          <ul>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-primary
                  "
                ></span>
                <span class="font-semibold">Total conversations</span>
              </span>
              <span>{{
                report.messengerConversationStats.numConversations
              }}</span>
            </li>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-warning
                  "
                ></span>
                <span class="font-semibold">Open</span>
              </span>
              <span>{{ report.messengerConversationStats.numStatusOpen }}</span>
            </li>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-danger
                  "
                ></span>
                <span class="font-semibold">Closed</span>
              </span>
              <span>{{
                report.messengerConversationStats.numStatusClosed
              }}</span>
            </li>
          </ul>
        </vx-card>
        <vx-card title="Messenger response time" class="mt-6">
          <vue-apex-charts
            type="radialBar"
            height="420"
            :options="engageMessengerResponseTime.chartOptions"
            :series="engageMessengerResponseTime.series"
          />
          <div class="flex justify-center">
            <span>Goal: 2 hours</span>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Email activity">
          <vx-timeline :data="engageEmailActivity" />

          <ul>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-primary
                  "
                ></span>
                <span class="font-semibold">Total email threads</span>
              </span>
              <span>{{ report.emailConversationStats.numConversations }}</span>
            </li>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-warning
                  "
                ></span>
                <span class="font-semibold">Open</span>
              </span>
              <span>{{ report.emailConversationStats.numStatusOpen }}</span>
            </li>
            <li class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid border-danger
                  "
                ></span>
                <span class="font-semibold">Closed</span>
              </span>
              <span>{{ report.emailConversationStats.numStatusClosed }}</span>
            </li>
          </ul>
        </vx-card>

        <vx-card title="Email response time" class="mt-6">
          <vue-apex-charts
            type="radialBar"
            height="420"
            :options="engageEmailResponseTime.chartOptions"
            :series="engageEmailResponseTime.series"
          />

          <div class="flex justify-center">
            <span>Goal: 24 hours</span>
          </div>
        </vx-card>
      </div>
    </div>

    <h4 class="mb-8">Booking <small class="text-grey">Not live</small></h4>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card
          title="Occupancy rate for top 10 venues, this year to date"
          class="mt-6"
        >
          <vue-apex-charts
            type="heatmap"
            height="420"
            :options="analyticsData.bookingAnalytics.chartOptions"
            :series="bookingSeries"
          />
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <vx-card title="Booking activity by type and date" class="mt-6">
          <vue-apex-charts
            type="line"
            height="420"
            :options="analyticsData.bookingAnalytics.chart2.chartOptions"
            :series="analyticsData.bookingAnalytics.chart2.series"
          />
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "@/views/ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";
import { mapGetters } from "vuex";
import moment from "moment";
import humanizeDuration from "humanize-duration";

import _ from "lodash";

export default {
  data() {
    return {
      hasLoaded: false,

      upcomingEvents: [
        {
          color: "success",
          icon: "UsersIcon",
          title: "Summertime campaign",
          desc: "Aloha beach bar - 359 recipients (SMS & Email)",
          time: "Fri. 04-09-2022 14:30",
        },
        {
          color: "primary",
          icon: "LayoutIcon",
          title: "VM cup beer",
          desc: "35 venues - ~5395 recipients (SMS)",
          time: "Mon. 07-09-2022 11:15",
        },
      ],

      checkpointReward: {},
      usersRegistered: {},
      userSessions: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      learningRadar: {},
      learningRadarOptions: {
        chartOptions: {
          labels: [
            "Cocktails",
            "Customers",
            "Interior",
            "Daily Operations",
            "Management",
            "Food",
          ],
          dataLabels: {
            style: {
              colors: [
                "#b9c3cd",
                "#b9c3cd",
                "#b9c3cd",
                "#b9c3cd",
                "#b9c3cd",
                "#b9c3cd",
              ],
            },
          },
          yaxis: {
            show: false,
          },
          grid: {
            show: false,
          },
          legend: { show: false },
          chart: {
            dropShadow: {
              enabled: true,
              blur: 8,
              left: 1,
              top: 1,
              opacity: 0.2,
            },
            toolbar: {
              show: false,
            },
          },
          stroke: {
            width: 0,
          },
          colors: ["#9f8ed7", "#1edec5"],
          plotOptions: {
            radar: {
              polygons: {
                strokeColors: [
                  "#e8e8e8",
                  "transparent",
                  "transparent",
                  "transparent",
                  "transparent",
                  "transparent",
                ],
                connectorColors: "transparent",
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              gradientToColors: ["#8e9ad6", "#1fcadb"],
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100],
            },
          },
          markers: {
            size: 0,
          },
        },
      },

      analyticsData,
      dispatchedOrders: [],
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
  },
  methods: {
    generateData(count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = (i + 1).toString();
        var y =
          Math.floor(Math.random() * (yrange.max - yrange.min + 1)) +
          yrange.min;
        series.push({
          x: x,
          y: y,
        });
        i++;
      }
      return series;
    },
  },
  computed: {
    ...mapGetters({
      report: "crmStatistics/latestReport",
    }),
    newGuestsSeries() {
      const lastThirtyDays = [...new Array(30)]
        .map((i, idx) =>
          moment().startOf("day").subtract(idx, "days").format("YYYY-MM-DD")
        )
        .map((date) => {
          const newGuests =
            this.report.guestProfileStats.mapProfilesByFirstActive30Days.find(
              (e) => e.date === date
            );
          return newGuests ? newGuests.count : 0;
        });
      return [
        {
          name: "Guests",
          data: lastThirtyDays,
        },
      ];
    },
    activeGuestsSeries() {
      const lastThirtyDays = [...new Array(30)]
        .map((i, idx) =>
          moment().startOf("day").subtract(idx, "days").format("YYYY-MM-DD")
        )
        .map((date) => {
          const newGuests =
            this.report.guestProfileStats.mapProfilesByLastActive30Days.find(
              (e) => e.date === date
            );
          return newGuests ? newGuests.count : 0;
        });
      return [
        {
          name: "Guests",
          data: lastThirtyDays,
        },
      ];
    },

    bookingSeries() {
      return [
        {
          name: "Aloha Beach Bar",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "Bar7 CPH",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "Bæst Cocktail Bar CPH",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "Aya Club Odense",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "Dorsia CPH",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "Heidi's Bier Bar Odense",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "Hvide Lam CPH",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "HIVE CPH",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
        {
          name: "Proud Mary CPH",
          data: this.generateData(12, {
            min: 0,
            max: 90,
          }),
        },
      ];
    },

    venueCampaignStatusData() {
      const all = {
        chartOptions: {
          ...analyticsData.productOrdersRadialBar.chartOptions,
          labels: ["Draft", "Pending", "Planned", "Completed"],
        },
        series: [
          this.report.venueCampaignStats.numStatusDraft,
          this.report.venueCampaignStats.numStatusPending,
          this.report.venueCampaignStats.numStatusPlanned,
          this.report.venueCampaignStats.numStatusCompleted,
        ],
        // statusData: [
        //   {
        //     orderType: "Completed",
        //     counts: 23043,
        //     color: "primary",
        //   },
        //   {
        //     orderType: "In-Progress",
        //     counts: 4758,
        //     color: "warning",
        //   },
        //   {
        //     orderType: "Signed Up ",
        //     counts: 14658,
        //     color: "danger",
        //   },
        // ],
      };
      // all.chartOptions.plotOptions.radialBar.dataLabels.total = {
      //   show: true,
      //   label: "Total",
      //   formatter: () => {
      //     return this.report.venueCampaignStats.numCampaigns;
      //   },
      // };

      return all;
    },

    masterCampaignStatusData() {
      const all = {
        chartOptions: {
          ...analyticsData.productOrdersRadialBar.chartOptions,
          labels: ["Draft", "Active", "Completed"],
        },
        series: [
          this.report.masterCampaignStats.numStatusDraft,
          this.report.masterCampaignStats.numStatusActive,
          this.report.masterCampaignStats.numStatusCompleted,
        ],
      };
      // all.chartOptions.plotOptions.radialBar.dataLabels.total = {
      //   show: true,
      //   label: "Total",
      //   formatter: () => {
      //     return this.report.venueCampaignStats.numCampaigns;
      //   },
      // };

      return all;
    },

    engageMessengerResponseTime() {
      return {
        chartOptions: {
          chart: {
            height: 420,
            type: "radialBar",
            offsetY: -40,
          },
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 135,
              dataLabels: {
                name: {
                  fontSize: "16px",
                  color: undefined,
                  offsetY: 0,
                },
                value: {
                  offsetY: 0,
                  fontSize: "14px",
                  color: undefined,
                  formatter: (val) => {
                    return humanizeDuration(
                      this.report.messengerConversationStats
                        .avgResponseTimeLast30Days * 1000,
                      { largest: 2, maxDecimalPoints: 0 }
                    );
                  },
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              shadeIntensity: 0.15,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 3,
          },
          // annotations: {
          //   texts: [
          //     {
          //       x: 156,
          //       y: 300,
          //       text: "Goal: 2 hours",
          //       textAnchor: "center",
          //       foreColor: undefined,
          //       fontSize: "20px",
          //       fontWeight: 400,
          //       appendTo: ".apexcharts-annotations",
          //       backgroundColor: "transparent",
          //       borderColor: "#c2c2c2",
          //       borderRadius: 0,
          //       borderWidth: 0,
          //       paddingLeft: 4,
          //       paddingRight: 4,
          //       paddingTop: 2,
          //       paddingBottom: 2,
          //     },
          //   ],
          // },

          labels: ["Average for 30 days"],
        },
        series: [
          (7200 /
            this.report.messengerConversationStats.avgResponseTimeLast30Days) *
            100,
        ],
        // series: [(7200 / 7500) * 100],

        // Goal is 2 hours aka 7200 seconds
      };
    },

    engageEmailResponseTime() {
      return {
        chartOptions: {
          chart: {
            height: 420,
            type: "radialBar",
            offsetY: -40,
          },
          plotOptions: {
            radialBar: {
              startAngle: -135,
              endAngle: 135,
              dataLabels: {
                name: {
                  fontSize: "16px",
                  color: undefined,
                  offsetY: 0,
                },
                value: {
                  offsetY: 0,
                  fontSize: "14px",
                  color: undefined,
                  formatter: (val) => {
                    return humanizeDuration(
                      this.report.emailConversationStats
                        .avgResponseTimeLast30Days * 1000,
                      { largest: 2, maxDecimalPoints: 0 }
                    );
                  },
                },
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              shadeIntensity: 0.15,
              inverseColors: false,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            dashArray: 3,
          },
          // annotations: {
          //   texts: [
          //     {
          //       x: 150,
          //       y: 300,
          //       text: "Goal: 24 hours",
          //       textAnchor: "center",
          //       foreColor: undefined,
          //       fontSize: "20px",
          //       fontWeight: 400,
          //       appendTo: ".apexcharts-annotations",
          //       backgroundColor: "transparent",
          //       borderColor: "#c2c2c2",
          //       borderRadius: 0,
          //       borderWidth: 0,
          //       paddingLeft: 4,
          //       paddingRight: 4,
          //       paddingTop: 2,
          //       paddingBottom: 2,
          //     },
          //   ],
          // },

          labels: ["Average for 30 days"],
        },
        series: [
          (86400 /
            this.report.emailConversationStats.avgResponseTimeLast30Days) *
            100,
        ],
        // series: [(7200 / 7500) * 100],

        // Goal is 24 hours aka 86400 seconds
      };
    },

    engageMessengerActivity() {
      return _.orderBy(
        this.report.messengerConversationStats.mapMessagesByEmployee,
        "count",
        "desc"
      ).map((e) => ({
        color: "primary",
        icon: "UsersIcon",
        title: e.displayName,
        desc: `${e.count} messages sent`,
      }));
    },

    engageEmailActivity() {
      return _.orderBy(
        this.report.emailConversationStats.mapMessagesByEmployee,
        "count",
        "desc"
      ).map((e) => ({
        color: "primary",
        icon: "UsersIcon",
        title: e.displayName,
        desc: `${e.count} emails sent`,
      }));
    },
    user() {
      let user = null;
      if (this.$AuthService.isAuthenticated()) {
        // Note that the dollar sign ($) is missing from this.msal
        user = {
          ...this.$AuthService.getUser(),
          profile: {},
        };
      }

      return user;
    },
  },
  async created() {
    this.hasLoaded = false;
    await this.$store.dispatch("crmStatistics/getLatest");
    this.hasLoaded = true;

    // Orders - Statistics
    this.userSessions = {
      series: [
        {
          name: "Users",
          data: [10, 15, 8, 15, 7, 12, 8],
        },
      ],
    };
    this.salesBarSession = {
      series: [
        {
          name: "Sessions",
          data: [75, 125, 225, 175, 125, 75, 25],
        },
      ],
      analyticsData: {
        session: 2700,
        comparison: {
          str: "Last 7 Days",
          result: +5.2,
        },
      },
    };

    // Users Registered
    this.usersRegistered = {
      series: [
        {
          name: "Users",
          data: [28, 40, 36, 52, 38, 60, 55],
        },
      ],
    };

    // Products Order
    this.productsOrder = {
      analyticsData: [
        {
          orderType: "Completed",
          counts: 23043,
          color: "primary",
        },
        {
          orderType: "In-Progress",
          counts: 4758,
          color: "warning",
        },
        {
          orderType: "Signed Up ",
          counts: 14658,
          color: "danger",
        },
      ],
      series: [70, 52, 26],
    };

    // Support Tracker
    this.supportTracker = {
      analyticsData: {
        openTickets: 163,
        meta: {
          "New Tickets": 29,
          "Open Tickets": 63,
          "Response Time": "1d",
        },
      },
      series: [83],
    };
    // Learning Radar
    this.learningRadar = {
      series: [
        {
          name: "Score",
          data: [80, 90, 30, 40, 100, 20],
        },
      ],
    };
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
